import React, { Component } from 'react';
import axios from 'axios'
import InternalServerError from './InternalServerError';
import CryptoJS from 'crypto-js';

class CodeVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            notVerified:'',
            btnDisabled:true,
            entryCount:0,
            internalServerError:false
        };
    this.onPrivacyBtnClick = this.onPrivacyBtnClick.bind(this);
    this.onButtonClick =this.onButtonClick.bind(this);
    this.handleChange = this.handleChange.bind(this); 
    this.countDown = this.countDown.bind(this);
    this.onReqBtnClick = this.onReqBtnClick.bind(this);
  };

  componentDidMount() {
    if(window.localStorage.getItem('unlock_timer')>0)
      setInterval(this.countDown, 1000)
    if(window.localStorage.getItem('entryCount') === null) {
      this.resetStorage();
    }
  }

  resetStorage() {
    window.localStorage.setItem('entryCount',0);
    window.localStorage.setItem('entryLimit',3);
    window.localStorage.setItem('privacyPortalLogin',true);
    window.localStorage.removeItem('unlock_timer')
  }

  handleChange(event) {
    const re = /^[0-9\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      this.setState({value: event.target.value});
    }
    if(event.target.value.length >= 6) {
      this.setState({btnDisabled:false})
    }
    else {
      this.setState({btnDisabled:true})
    }
  }

   async onPrivacyBtnClick() {
    if (window.localStorage.getItem('entryCount') < window.localStorage.getItem('entryLimit')) {
        var body = {
          "requestId": this.props.CustomerReqId,
          "otpDttm": this.props.timeStamp,
          "otp": this.state.value,
          "userEmail": this.props.customerEmail,
          "clientName": "Customer_portal",
          "clientToken": this.props.clientToken
        }
        var obj = { "url": process.env.REACT_APP_DPR_API_URL+"/OTPVerify",
                    "method":'POST',
                    "otp_verify": "otpVerify",
                   // "refresh_expire":window.localStorage.getItem('refresh_token_expire'),
                    "body": CryptoJS.AES.encrypt(JSON.stringify(body), this.props.password).toString()
                  };
        try {
          const response = await axios({
          url: '/servercall/DPRAPI',
          method: 'POST',
          data: obj
          })

          let bytes = CryptoJS.AES.decrypt(response.data,this.props.password);
          let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          
          if(decryptRes.access_token && decryptRes.refresh_token){
            window.localStorage.setItem('access_token', decryptRes.access_token);
            window.localStorage.setItem('refresh_token', decryptRes.refresh_token);
            window.localStorage.setItem('access_token_expire', decryptRes.access_token_expire);
            window.localStorage.setItem('refresh_token_expire', decryptRes.refresh_token_expire);
            window.localStorage.setItem('token_type', decryptRes.type);
            window.localStorage.setItem('privacyPortalLogin', true);
            this.resetStorage();
            this.props.onParentCall();
          }
          else if(decryptRes.status === 'NOT VERIFIED'){
            this.setState({value: '',
              notVerified: true
            });  
            window.localStorage.setItem('entryCount',parseInt(window.localStorage.getItem('entryCount'))+1);
            if(window.localStorage.getItem('entryCount') === window.localStorage.getItem('entryLimit')) {
              window.localStorage.setItem('privacyPortalLogin',false);
              this.props.onAccountLock();
              setInterval(this.countDown, 1000)
            }
            this.setState({entryCount: this.state.entryCount});
          } 
          else {
            this.setState({internalServerError:true});
          }
        } 
        catch(e) {
          console.log(e);
          this.setState({internalServerError:true});
          return e;
        } 
    }
  }

  countDown(){
    if (window.localStorage.getItem('unlock_timer') <= 0) { 
      window.localStorage.setItem('privacyPortalLogin',true);
    }
    else {
      window.localStorage.setItem('unlock_timer',window.localStorage.getItem('unlock_timer')-1)
    } 
    this.setState({})   
  }

  onButtonClick() {
    this.props._onButtonClick();
    this.setState({requestCode: false});
  }

  onReqBtnClick() {
    this.setState({notVerified:''})
    this.resetStorage();
    this.onButtonClick()
  }
  
  render() {
    return (
      this.state.internalServerError ? <InternalServerError/> :
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className="max-width-20 position-center margin-center">
                <p className="margin-top-1"> Access Code will be sent.</p>
                <p className="margin-top-1"> A one-time access code will be sent to 
                    <span> {window.localStorage.getItem('customerEmail') === null ?this.props.customerEmail:window.localStorage.getItem('customerEmail')} </span> 
                    if there is an account 
                    associated with that email address. This code will be valid for 
                    <span> {Math.floor(window.localStorage.getItem('otpExpiration') === null ? this.props.otpExpiration/60: (window.localStorage.getItem('otpExpiration')) / 60)} </span> minutes.
                </p>
                {parseInt(window.localStorage.getItem('entryCount')) === 3 &&
                 parseInt(window.localStorage.getItem('unlock_timer'))>0 ? 
                  <div className="code-error-visible  margin-top-1">Your account has been locked due to 3 failed attemps.It will be unlocked in {window.localStorage.getItem('unlock_timer')} seconds.</div> :''}
                {window.localStorage.getItem('unlock_timer') == 0 ? 
                  <div>
                    <div className="margin-top-1">Please click on the below link to request for new access code</div>
                    <p className="margin-top-2"><a href="#" onClick={this.onReqBtnClick}>Request New Access Code</a></p>
                  </div>: ''} 
                {window.localStorage.getItem('entryCount') < window.localStorage.getItem('entryLimit') ? 
                <div>
                  <div className="margin-top-1 margin-bottom-1" id="access-code">
                      <p><label className="text-bold">Enter Access code</label></p>
                      <p className={this.state.notVerified ? 'code-error-visible' : 'code-error-hide'}>Please enter a valid access code</p>
                      <input type="text" 
                        value={this.state.value} 
                        maxLength="6" 
                        className={this.state.notVerified ? 'code-verify-error' : ''} 
                        onChange={this.handleChange} 
                      />
                  </div>
                  <button id="privacy-button" disabled={this.state.btnDisabled} onClick={this.onPrivacyBtnClick} > Go to Privacy Portal</button>
                  <p className="margin-top-2"><a href="#" onClick={this.onButtonClick}>Request New Access Code</a></p>
                </div>: 
              '' }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CodeVerification;
